import PropTypes from "prop-types";
import {
	createContext,
	FC,
	ReactNode,
	useEffect,
	useMemo,
	useState
} from "react";
import axios from "../common/axios";
import { IUserProps } from "../common/data/userDummyData";

interface IuserData {
  full_name: string; // "Test đổi tên",
  address_id: string; // 14,
  phone: string; // "0879999888",
  agency_id: string; // 1,
  email: string; // "aaa1@gmail.com",
  agency_name: string; // "Itel",
	TaxCode: string; // "0011223211",
	avatar: string;
}
export interface IAuthContextProps {
  user: string;
  setUser?(...args: unknown[]): unknown;
  userData: Partial<IuserData>;
  setUserData: any;
}

const AuthContext = createContext<IAuthContextProps>({} as IAuthContextProps);

interface IAuthContextProviderProps {
  children: ReactNode;
}
export const AuthContextProvider: FC<IAuthContextProviderProps> = ({
  children,
}) => {
  const [user, setUser] = useState<string>(
    localStorage.getItem("facit_authUsername") || ""
  );
  const [userData, setUserData] = useState<Partial<IUserProps>>({});

  useEffect(() => {
    if (!user) return;
    axios
      .get("/getUserInfo")
      .then((res) => {
        setUserData(res.data.result);
      })
      .catch((err) => console.log(err));
  }, [user]);

  const value = useMemo(
    () => ({
      user,
      setUser,
      userData,
      setUserData,
    }),
    [user, userData]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
AuthContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthContext;
